export default "__VITE_ASSET__DNLFLNu9__"